import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  goldenGoalSettingsConfigurations: [],
};

export const goldenGoalSettingsSlice = createSlice({
  name: 'goldenGoalSettings',
  initialState,
  reducers: {
    aGetGoldenGoalSettingsSuccess: (state, action) => {
      state.goldenGoalSettingsConfigurations = action.payload.goldenGoalSettingsConfigurations;
    },
    aUpdateGoldenGoalSettingsSuccess: (state, action) => {
      state.goldenGoalSettingsConfigurations = action.payload;
    },
  },
});

export const {
  aGetGoldenGoalSettingsSuccess,
  aUpdateGoldenGoalSettingsSuccess,
} = goldenGoalSettingsSlice.actions;

export default goldenGoalSettingsSlice.reducer;
